import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';   // <-- Make sure this line is here
import './styles/design-system.css';
import './styles/pro-motion-ui.css';
import './styles/admin-dashboard-ui.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { registerServiceWorker } from './utils/registerServiceWorker';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

registerServiceWorker();
